import script from "./Budget.vue?vue&type=script&lang=ts&setup=true"
export * from "./Budget.vue?vue&type=script&lang=ts&setup=true"

import "./Budget.vue?vue&type=style&index=0&id=58b45b16&lang=scss"

const __exports__ = script;

export default __exports__